interface CacheItem {
  key: string;
  expires: number;
}

export default class ItemCache<T> {
  constructor(private key: string, private ttlInMs: number, private maxItems: number) {}

  public getItem(key: string): T | null {
    const now = new Date().getTime();
    const items: CacheItem[] = JSON.parse(localStorage.getItem(`${this.key}.cache.items`) || "[]");
    const index = items.map((i) => i.key).indexOf(key);
    const cacheItem = index >= 0 ? items[index] : null;
    if (cacheItem && cacheItem.expires > now) {
      console.log("load from cache");
      const storedItem = localStorage.getItem(`${this.key}.cache.items.${key}`);
      return storedItem ? (JSON.parse(storedItem) as T) : null;
    }
    return null;
  }

  public storeItem(key: string, item: T): T {
    const expires = new Date().getTime() + this.ttlInMs;
    const items: CacheItem[] = JSON.parse(localStorage.getItem(`${this.key}.cache.items`) || "[]");
    const index = items.map((i) => i.key).indexOf(key);
    const cacheItem = index >= 0 ? items[index] : null;
    if (cacheItem) {
      cacheItem.expires = expires;
      this.store(items, key, item);
    } else if (items.length < this.maxItems) {
      items.push({
        key,
        expires,
      });
      this.store(items, key, item);
    } else {
      const oldestValue = items.reduce((previousValue, currentValue) => {
        if (previousValue.expires < currentValue.expires) {
          return previousValue;
        }
        return currentValue;
      });
      localStorage.removeItem(`${this.key}.cache.items.${oldestValue.key}`);
      const oldestIndex = items.map((i) => i.key).indexOf(oldestValue.key);
      items.splice(oldestIndex, 1, {
        key,
        expires,
      });
      this.store(items, key, item);
    }
    return item;
  }

  private store(items: CacheItem[], key: string, item: T): void {
    try {
      localStorage.setItem(`${this.key}.cache.items`, JSON.stringify(items));
      localStorage.setItem(`${this.key}.cache.items.${key}`, JSON.stringify(item));
    } catch (error) {
      console.warn(error);
      console.log("Clear local storage");
      localStorage.clear();
    }
  }
}
